import { Text } from '@/components/ui/text'
import SetupTitle from '@components/SetupTitle'
import type { Tables } from '@hvf/contracts'
import { Show } from 'solid-js'
import { Flex, Grid } from 'styled-system/jsx'

export default function Header(props: { setup: Tables<'setup'> }) {
  return (
    <Grid gap='7px'>
      <Flex justifyContent='space-between' alignItems='center' gap='12px'>
        <SetupTitle
          setup={props.setup}
          fontSize='28px'
          iconSize={16}
          gap='9px'
          maxW='none'
        />

        <Show when={props.setup.exchange}>
          <Text
            flexShrink={0}
            fontSize='11.5px'
            fontWeight='600'
            letterSpacing='.03em'
            color='editorialInk'
            bg='editorialPanel'
            px='10px'
            py='5px'
            borderRadius='8px'
            border='1px solid var(--colors-editorial-hair-strong)'
          >
            {props.setup.exchange}
          </Text>
        </Show>
      </Flex>

      <Text
        fontSize='19px'
        fontWeight='600'
        lineHeight='1.28'
        letterSpacing='-.01em'
        color='editorialInk'
      >
        {props.setup.title}
      </Text>
    </Grid>
  )
}
